import React from "react";
import T from "prop-types";

import BoxesLabeled from "2g-box-labeled";

import TextComponent from "b2b/components/text-component";
import useServerMessage from "b2b/i18n/useServerMessage";

import ZadostiGroupsZdroj from "./ZadostiGroupsZdroj";

function ZadostiGroupTypZdroje({ label, list, loading, onChange, value }) {
  const getServerMessage = useServerMessage();
  return (
    <BoxesLabeled.Info
      label={<TextComponent loading={loading}>{label}</TextComponent>}
    >
      <div className="b2b-ZadostiGroups-typZdroje">
        {list?.map(item => {
          const { zdroj } = item;
          return (
            <ZadostiGroupsZdroj
              data={item}
              key={`${zdroj.id}`}
              isActive={value?.id == zdroj.id}
              label={getServerMessage(zdroj, "nazev")}
              loading={loading}
              onChange={onChange}
            />
          );
        })}
      </div>
    </BoxesLabeled.Info>
  );
}

ZadostiGroupTypZdroje.propTypes = {
  label: T.string,
  list: T.array.isRequired,
  loading: T.bool,
  onChange: T.func.isRequired,
  value: T.object
};

export default React.memo(ZadostiGroupTypZdroje);
